import { Button, Spinner } from 'react-bootstrap';
import { ArrowClockwise } from 'react-bootstrap-icons';
import { useDeployClock } from '@/hooks/useDeployClock';
import { formatNzDateTime, timeAgo } from '@/utils/relativeTime';
import './deployments.css';

interface RefreshButtonProps {
  onRefresh: () => void;
  busy: boolean;
  /** When the list was last read (epoch ms). */
  refreshedAt: number | null;
  /** The list keeps itself current while a run is live. */
  auto?: boolean;
}

/** Refresh, with how fresh the list is beside it, so nobody has to guess whether they are looking at old data. */
export function RefreshButton({ onRefresh, busy, refreshedAt, auto = false }: RefreshButtonProps) {
  const now = useDeployClock(refreshedAt !== null);
  return (
    <span className="deploy-refresh">
      {refreshedAt !== null && (
        <span
          className="deploy-refresh__age"
          title={`${formatNzDateTime(refreshedAt)}${auto ? '. Live runs update by themselves every 10 seconds.' : ''}`}
        >
          {auto ? 'Live. ' : ''}Refreshed {timeAgo(refreshedAt, now)}
        </span>
      )}
      <Button variant="outline-secondary" size="sm" onClick={onRefresh} disabled={busy}>
        {busy ? <Spinner size="sm" className="me-1" /> : <ArrowClockwise size={12} className="me-1" />}
        Refresh
      </Button>
    </span>
  );
}

export default RefreshButton;
